<template>
    <div id="foo" @click="reload">
        <div class="center">
            <div class="paper main">
                <div class="text">
                    <h2>{{ msg.title }}</h2>
                    <h1>{{ msg.multiple }}</h1>
                </div>
                <svg x="0px" y="0px" viewBox="0 0 180 100">
                    <path class="st4" d="M29.8,9.2l2.7-1.6c0,0,13.9,4,21.4,3.7l1.1,4.3l2.1-3.5c0,0,20.9,2.4,29.2,1.1l-1.1,2.1l3.5,2.1l1.9,7.5
			l2.1-12.3c0,0,20.9-1.3,36.1-5.4l2.4,2.9l1.6-3.7c0,0,12-1.9,14.2-2.4l4,1.6c0,0,10.7,54.1,4.3,83.3c0,0-26.2-2.4-31.6-1.9
			l-1.3-2.1l-0.5,2.1c0,0-21.1-0.5-28.1,0.5l-1.9-4.8L90.3,87c0,0-11.8,0.3-14.5,0.5l-0.3-2.1l-2.1,2.9c0,0-26.8,0.5-39.6,2.4
			c0,0-9.4-35.9-8.8-57.3c0.5-21.4,2.1-15.8,2.1-15.8S30,12.7,29.8,9.2z" />
                    <path class="st5" d="M143.8,28c-1.1-3-3.2-5.7-5.7-7.7c-4.4-3.5-10.2-4.8-15.7-4.7c-6,0.2-11.2,2.3-16.5,4.8
			c-4.7,2.2-9.6,4-15,3.1L90.5,25l-0.4-1.6c-6.4-1.3-12.4-4.1-18.8-5.4c-5.9-1.2-12.5-1.5-18.4-0.7c-6.6,0.8-12.3,3.8-16.2,9.4
			c-3.4,5-5,11.1-5.6,17c-1.7,15.9,2.6,35.5,15.5,46c12.7-0.9,26.9-1.2,26.9-1.2l2.1-2.9l0.3,2.1c2.7-0.3,14.5-0.5,14.5-0.5l1.6-4.3
			l1.9,4.8c3.3-0.5,9.7-0.7,15.5-0.7c0.1-0.1,0.1-0.1,0.2-0.2c2.8-2.8,4.4-7.7,8.7-8.5c2.3-0.4,4.7,0.2,6.9,0.9
			c2.8,0.9,5.5,2,8.3,2.7c5.2,1.4,11.4,1.6,14.7-3.4c2.5-3.9,3.2-8.9,3.4-13.4c0.2-4.7-0.1-9.4-1.6-13.8c-0.6-1.8-1.4-3.3-2.7-4.7
			c-0.9-1-2-1.8-2.9-2.8c-1.6-1.9-1.7-3.8-0.9-6.1C144.4,34.6,144.9,31.2,143.8,28z" />
                    <path class="st6" d="M42.4,89.7c-3.2-7.1-5.9-14.5-7.7-22.1c-1.6-6.8-2.7-13.8-3.6-20.8C29.5,34.1,29,20.1,34.3,8.1
			c-1.1-0.3-1.8-0.5-1.8-0.5l-2.7,1.6c0.3,3.5-2.7,8.6-2.7,8.6s-1.6-5.6-2.1,15.8s8.8,57.3,8.8,57.3c2.5-0.4,5.5-0.7,8.7-0.9
			C42.4,89.9,42.4,89.8,42.4,89.7z" />
                    <path class="st6" d="M151,5.8l-4-1.6c-0.7,0.2-2.7,0.5-4.9,0.9c2.4,7.1,4.3,14.4,5.5,21.9c2.4,14.8,2.1,30.2-1.8,44.7
			c-1.5,5.6-3.5,11-6,16.1c7.9,0.6,15.5,1.3,15.5,1.3C161.7,59.8,151,5.8,151,5.8z" />
                    <path class="st1" d="M52.3,75.1c0,0-0.8,3.2-3.2,1.1s-18.2-25.4-6.7-42.8s30,1.1,44.7,0.3s13.1-8.3,26.5-7.8s19,4,19.5,10.2
			s-5.6,4-4,8c1.6,4,7.8-0.5,11,3.7c3.2,4.3,3.2,13.9-3.7,14.7c-7,0.8-14.5-1.6-25.2-8.3s-15,5.9-11.8,10.2s7.8,10.2,1.6,12.8
			s-15.5,2.7-26.5-1.3s-12.3,2.9-16.6,1.3C53.6,75.6,54.7,73.8,52.3,75.1z" />
                    <path class="st1"
                        d="M74.2,27.4c0,0,4,0.3,3.7-0.8c-0.3-1.1-4.6-2.4-5.1-1.1C72.3,26.9,74.2,27.4,74.2,27.4z" />
                    <path class="st1" d="M40.2,28.8c0,0-2.7-2.9-0.8-4s4.6-0.8,4.3,0.8C43.4,27.2,41,29.8,40.2,28.8z" />
                    <path class="st1" d="M135.6,75.4c0,0-1.4-3.8,2-4s3.6,1.4,3,2.4S135.8,77.2,135.6,75.4z" />
                </svg>
            </div>

            <div class="paper left">
                <svg x="0px" y="0px" viewBox="0 0 180 100">
                    <path class="st0"
                        d="M15.8,92.5l-1,4.5c0,0,4.3,3.2,9.4,2.9l0.8-2.1l1,2.2c0,0,5.6,0,8.8-2.9l-2.7-4.3L15.8,92.5z" />
                    <path class="st1"
                        d="M9.7,5.5c0,0,7.8,49.8,3.5,87.3c0,0,12,9.1,22.5,0c0,0-18.2-46.3-3.7-88.6C31.9,4.1,22.3,0.9,9.7,5.5z" />
                    <path class="st2"
                        d="M9.7,5.5c0,0,7,3.2,15.8,1.1l1.9,8.6l1.1-9.4L32,4.2C31.9,4.1,22.5,0.1,9.7,5.5z" />
                    <path class="st3" d="M12,3.5c0,0,1.9-2.3,10-2.4l0.4,1.3l1.5-1.2c0,0,2.7-0.3,4.3,0.8c0,0-5,3.6-6,4c-1.1,0.4-0.8,0.9-2.7,0.4
			C17.6,5.9,12.6,4.4,12,3.5z" />
                    <path class="st0" d="M13,6.7l-1-3.2c0,0,4,1.1,8.2,0.9l0.9,1.9l1.3-1.9c0,0,4-0.8,5.8-2.4l-1.3,11.1l-1.3-6.6
			C25.5,6.6,20.1,8.3,13,6.7z" />
                </svg>
            </div>

            <div class="paper right">
                <svg x="0px" y="0px" viewBox="0 0 180 100">
                    <path class="st0"
                        d="M164.2,91.4l1.1,4.6c0,0-4.3,3.2-9.4,2.9l-0.8-2.1l-1.1,2.1c0,0-5.6,0-8.8-2.9l2.7-4.3L164.2,91.4z" />
                    <path class="st1"
                        d="M170.3,4.4c0,0-7.8,49.8-3.5,87.3c0,0-12,9.1-22.5,0c0,0,18.2-46.3,3.7-88.6C148.1,3.1,157.7-0.1,170.3,4.4z" />
                    <path class="st2"
                        d="M170.3,4.4c0,0-7,3.2-15.8,1.1l-1.9,8.6l-1.1-9.4L148,3.1C148.1,3.1,157.5-0.9,170.3,4.4z" />
                    <path class="st3" d="M168,2.4c0,0-1.9-2.3-10-2.4l-0.4,1.3l-1.5-1.2c0,0-2.7-0.3-4.3,0.8c0,0,5,3.6,6,4c1.1,0.4,0.8,0.9,2.7,0.4
			S167.4,3.3,168,2.4z" />
                    <path class="st0" d="M167,5.6l1.1-3.2c0,0-4,1.1-8.2,0.9L159,5.2l-1.3-1.9c0,0-4-0.8-5.8-2.4l1.3,11.1l1.3-6.6
			C154.5,5.5,159.9,7.2,167,5.6z" />
                </svg>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'paper',
    props: ['msg'],
    mounted() {
        let paper = document.getElementsByClassName('paper')
        let foo = document.getElementById('foo')
        setTimeout(function () {
            for (let i = 0; i < paper.length; i++) {
                paper[i].classList.add("play");
            }
            foo.classList.add("foo1")
        }, this.msg.delay);
    },
    methods: {
        reload() {
            location.reload()
        }
    }
}
</script>

<style scoped>
#foo {
    z-index: 9999;
    width: 100vw;
    height: 100vh;
    position: fixed;
    opacity: 1;
    transition: all 1s;
}

.foo1 {
    background-color: #0007;
}

.text {
    color: #4e342e;
    position: absolute;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
    text-align: center;
}

.text h1 {
    font-size: 10em;
}

.text h2 {
    font-size: 4em;
}

.center {
    position: absolute;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
    width: 80%;
    height: auto;
    display: grid;
    grid-template-columns: 1fr;
}

.paper {
    grid-row-start: 1;
    grid-column-start: 1;
    opacity: 0;
}

.left {
    transform: translateX(35%);
}

.right {
    transform: translateX(-35%);
}

.main {
    transform-origin: 50% 50%;
    transform: scale(0.2, 1);
}

.play {
    animation: go ease-in-out 1s forwards;
}

@keyframes go {
    10% {
        opacity: 1;
    }
    to {
        transform: translateX(0);
        transform: scale(1);
        opacity: 1;
    }
}

.st0{fill:#E5AF6E;}
	.st1{fill:#EFBF7B;}
	.st2{fill:#D19854;}
	.st3{fill:#C48847;}
	.st4{fill:#F9CE8A;}
	.st5{fill:#F2C686;}
	.st6{opacity:0.85;fill:#E5AE6C;}
</style>

